export default __webpack_public_path__ + "static/media/shadnagar_5k-1.29542cac.webp";